export default "__VITE_ASSET__C5GT$0Km__"